export const FichaIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <rect width={32} height={32} fill="#2196F3" fillOpacity={0.2} rx={16} />
    <path
      fill="#2196F3"
      d="M11 9.5h6.703L21 12.797V22.5H11v-13Zm1 1v11h8v-8h-3v-3h-5Zm6 .703V12.5h1.297L18 11.203ZM13 14.5h6v1h-6v-1Zm0 2.5h3.5v1H13v-1Zm4.5 0H19v1h-1.5v-1ZM13 19h3.5v1H13v-1Zm4.5 0H19v1h-1.5v-1Z"
    />
  </svg>
);
